import styled from 'styled-components/macro';

export const SliderContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 150px;
  background-color: ${({ theme }) => theme.dark};
  padding: 0 75px 0 75px;

  > div {
    margin: 0 !important;
    align-items: center;
    width: 100%;
    height: 100%;

    .slick-arrow {
      display: flex;
      background-color: transparent;
    }

    .slick-arrow::before {
      display: none;
      background-color: transparent;
    }

    .slick-arrow:hover {
      background-color: transparent;
    }
  }

  .slick-track {
    display: flex;
    align-items: center;
    width: 95%;
  }

  .variable-width .slick-slide p {
    background: blue;
    height: 100px;
    color: #fff;
    margin: 5px;
    line-height: 100px;
    text-align: center;
  }
  .center .slick-center h3 {
    color: #e67e22;
    opacity: 1;
    transform: scale(1.08);
  }
  .center h3 {
    opacity: 0.8;
    transition: all 300ms ease;
  }
  .content {
    padding: 20px;
    margin: auto;
    width: 90%;
  }
  .slick-slide .image {
    padding: 10px;
  }
  .slick-slide img {
    border: 5px solid #fff;
    display: block;
    margin: auto;
  }
  .slick-slide img.slick-loading {
    border: 0;
  }
  .slick-slider {
    margin: 30px auto 50px;
  }
  .slick-dots {
    margin-left: 0;
  }
  .slick-thumb {
    bottom: -45px;
  }
  .slick-thumb li {
    width: 60px;
    height: 45px;
  }
  .slick-thumb li img {
    filter: grayscale(100%);
  }
  .slick-thumb li.slick-active img {
    filter: grayscale(0%);
  }
  @media (max-width: 768px) {
    h3 {
      font-size: 24px;
    }
    .center {
      margin-left: -40px;
      margin-right: -40px;
    }
    .center .slick-center h3 {
      color: #e67e22;
      opacity: 1;
      transform: scale(1);
    }
    .center h3 {
      opacity: 0.8;
      transform: scale(0.95);
      transition: all 300ms ease;
    }
  }
  .slick-vertical .slick-slide {
    height: 180px;
  }
  .slick-arrow {
    background-color: grey;
    /* color: black; */
  }
  .slick-arrow:hover {
    background-color: grey;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    padding: 0 50px;
    height: 88px;
    .slick-prev svg {
      position: relative;
      right: 10px;
    }
    .slick-next svg {
      position: relative;
      left: 10px;
    }
    .slick-slide > div {
      width: ${window.innerWidth - 100}px;
    }
  }
`;
